import { render } from "./EventsCalendar.vue?vue&type=template&id=2bc40bf3&ts=true"
import script from "./EventsCalendar.vue?vue&type=script&lang=ts"
export * from "./EventsCalendar.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/FK/Events/EventsCalendar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2bc40bf3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2bc40bf3', __exports__)) {
    api.reload('2bc40bf3', __exports__)
  }
  
  module.hot.accept("./EventsCalendar.vue?vue&type=template&id=2bc40bf3&ts=true", () => {
    api.rerender('2bc40bf3', render)
  })

}


export default __exports__